import { useDispatch, useSelector } from "react-redux";
import { selectIsSavingSettings, validateSettings } from "../app/settingsSlice";
import { useMemo } from "react";

/**
 * Custom hook to validate settings
 * @param {string} setting - The setting identifier to validate
 * @returns {boolean} - Returns true if setting is valid or not provided, false otherwise
 */
export const useSettingsValidation = setting => {
    const dispatch = useDispatch();
    const isSavingSetting = useSelector(selectIsSavingSettings);

    return useMemo(() => {
        if (!setting) return true;
        return !isSavingSetting && dispatch(validateSettings(setting));
    }, [setting, isSavingSetting, dispatch]);
};
